import { HTMLAttributes } from 'react'

import { sectionsMap } from '@/components/sections'

import { WPPageData } from '@/types'

export type BuilderProps = HTMLAttributes<HTMLElement> & {
  pageData?: WPPageData
}

const Builder = ({ pageData }: BuilderProps) => {
  return (
    <>
      {pageData?.acf?.builder?.map(({ acf_fc_layout, ...section }, index) => {
        const Section = sectionsMap[acf_fc_layout]

        if (!Section) return null

        return (
          <Section
            key={`section-${index}`}
            className="relative"
            {...section}
            {...(acf_fc_layout === 'gallery_download' ? { pageData } : {})}
            {...(['image_paragraph', 'vertical_image_paragraph'].includes(
              acf_fc_layout
            )
              ? { is_in_lightbox: pageData?.type === 'mood' }
              : {})}
          />
        )
      })}
    </>
  )
}

export default Builder
